import { z } from "zod";

export const InsuranceType = z.enum(["Occurrence", "ClaimsMade"]);

export type InsuranceTypeEnum = z.infer<typeof InsuranceType>;

export const InsuranceTypeDisplayName: Record<InsuranceTypeEnum, string> = {
  [InsuranceType.enum.Occurrence]: "Occurrence",
  [InsuranceType.enum.ClaimsMade]: "Claims Made",
};
